import { render } from "./useDetailMobile.vue?vue&type=template&id=7e11cc64&scoped=true"
import script from "./useDetailMobile.vue?vue&type=script&lang=js"
export * from "./useDetailMobile.vue?vue&type=script&lang=js"

import "./useDetailMobile.vue?vue&type=style&index=0&id=7e11cc64&lang=less&scoped=true"
import "./useDetailMobile.vue?vue&type=style&index=1&id=7e11cc64&lang=css"
import "./useDetailMobile.vue?vue&type=style&index=2&id=7e11cc64&lang=less"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e11cc64"]])

export default __exports__